import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-/i;

export function resolveDisplayName(profile: Record<string, unknown> | undefined): string {
  if (!profile) return "Guest";
  const given = profile.given_name as string | undefined;
  const family = profile.family_name as string | undefined;
  if (given) return family ? `${given} ${family}` : given;
  const name = profile.name as string | undefined;
  if (name && !UUID_RE.test(name)) return name;
  return (profile.email as string | undefined) ?? "User";
}

export function resolveFirstName(profile: Record<string, unknown> | undefined): string | null {
  if (!profile) return null;
  const given = profile.given_name as string | undefined;
  if (given) return given;
  const full = resolveDisplayName(profile);
  if (full === "User" || full === "Guest") return null;
  return full.split(/[\s@]/)[0] || null;
}

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;
const pad = (n: number) => String(n).padStart(2, "0");

// Formats a date as "2026-Apr-27 12:46:58"
export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${MONTHS[d.getMonth()]}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
